import { Outlet, useNavigation } from "react-router-dom";
import classes from "./Root.module.css";
import MainNavigation from "../components/MainNavigation";
import { isLoggedIn } from "../util/getToken";
import LeftBar from "../components/LeftBar";

function RootLayout() {
  // const navigation = useNavigation();

  return (
    <>
      <div className="mainNavigation">
        <MainNavigation />
      </div>
      <div className={classes.belowMainNav}>
        <div>
          <LeftBar />
        </div>
        <div className={classes.mainSection}>
          <main>
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
}

export default RootLayout;

// Boolean so Home / MainNavigation / LeftBar can treat truthy as logged-in
export function loader() {
  return isLoggedIn();
}
